import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  titles: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'WhatsApp-meldingen inschakelen',
    [ONBOARDING_GUIDE_STEPS.Voice]: 'Geautomatiseerde oproepen over openstaande bestellingen',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Openingstijden',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Locatie',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Restaurantidentiteit',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Afhaaltijd',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Bezorgtijd',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Personeelsgegevens',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Menu importeren',
    [ONBOARDING_GUIDE_STEPS.Favourites]: 'Favorieten',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Uitverkochte items',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Promotiecodes',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Galerie',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]: 'Restaurantlogo en primaire kleur toevoegen',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Folders bestellen',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Storefront aanmaken',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Live bestellingen inschakelen',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Google Business inschakelen',
  },
  descriptions: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Controleer of eigenaar/contactpersoon WhatsApp heeft',
    [ONBOARDING_GUIDE_STEPS.Voice]:
      'Controleer of het restaurantnummer correct is voor geautomatiseerde oproepen om bestellingen niet te missen',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Openingstijden van restaurant instellen',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Restaurantlocatie instellen',
    [ONBOARDING_GUIDE_STEPS.Identity]:
      'Stel het restauranttype en de keukens in die op de winkelomgeving worden weergegeven',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Afhaaltijdinstellingen instellen',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Bezorgtijdinstellingen instellen',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Personeelsgegevens instellen',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Menu importeren van externe aanbieder',
    [ONBOARDING_GUIDE_STEPS.Favourites]:
      'Markeer 4 items als favoriet. Vraag het restaurant welke de 4 meest populaire gerechten zijn',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Gedrag van uitverkochte items instellen',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Promocodes instellen',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Galerij bijwerken',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]:
      'Haal het logo op van het restaurant of de restaurantpagina op Lieferando. Sla het logo daarvan op. Kies de kleur die het meest aanwezig is in het restaurantlogo',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Flyerontwerp bewerken en bestelling plaatsen',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Storefront aanmaken en website indien nodig bewerken',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Live bestellingen inschakelen ("!alleen op lanceerdatum!")',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Google Business-account koppelen',
  },
  buttons: {
    mark_as_complete: 'Markeer als voltooid',
  },
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
  },
};
